import { useEffect, useState } from "react";

type Breakpoint = "sm" | "md";

const breakpoints: Record<Breakpoint, number> = {
  sm: 768,
  md: 991,
};

export function useBreakpoint(breakpoint: Breakpoint): boolean {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return width <= breakpoints[breakpoint];
}

export function useIsMobile(): boolean {
  return useBreakpoint("sm");
}

export function useIsTablet(): boolean {
  return useBreakpoint("md");
}
